export const ADMIN_ROLE = "admin";
export const PROJECT_MANAGER_ROLE = "project_manager";

export function isAdminRole(role) {
  return typeof role === "string" && role.trim().toLowerCase() === ADMIN_ROLE;
}

export function isProjectManagerRole(role) {
  return (
    typeof role === "string" &&
    role.trim().toLowerCase() === PROJECT_MANAGER_ROLE
  );
}
